import React, { } from "react";
import { useHistory, useParams } from "react-router-dom";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import parseISO from "date-fns/parseISO";
import SyncIcon from "../../assets/icons/sync-icon.svg";
import EditIcon from "../../assets/icons/edit-icon.svg";
import RenderByPermission from "components/RenderByPermission";
// import DeleteIcon from "../../assets/icons/trash-icon.svg";

const WorkspaceListView = ({
  workspaces,
  openEditDialog,
  openDeleteDialog,
  handleSelectedWorkspace
}) => {

  const history = useHistory();
  const params = useParams();


  return (
    <div className="sync__table">
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Created</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {workspaces.map((workspace, i) => {
              if (workspace.display === true) {
                return (
                  <tr key={i}>
                    <td>
                      <p className="title m-0">{workspace.space_id}</p>
                    </td>
                    <td>
                      <p className="title m-0">{workspace.name}</p>
                    </td>
                    <td>{workspace.created_on
                      ? formatDistanceToNow(parseISO(workspace.created_on)) + " ago"
                      : ""}</td>
                    <td>
                      <span className="info">
                        {workspace.details && workspace.details.status
                          ? workspace.details.status
                          : "none"}
                      </span>

                    </td>
                    <td>
                      <div className="dropdown">
                        <span
                          className="dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          ...
                      </span>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <span
                            className="dropdown-item"
                            onClick={() => {
                              let link = `/dashboard/organisation/${params.id}/workspaces/${workspace.space_id}/apps`;

                              history.push(link);
                            }}
                          >
                            <img src={SyncIcon} alt="icon" /> View Apps
                        </span>
                        <RenderByPermission>
                          <span
                            className="dropdown-item"
                            onClick={() => {
                              handleSelectedWorkspace(workspace.space_id)
                              openEditDialog(workspace.space_id)
                            }}
                            >
                              <img src={EditIcon} alt="icon" width="12px" />
                              Edit Workspace
                          </span>
                        </RenderByPermission>
                          {/* <span
                            className="dropdown-item"
                            onClick={() => {
                              handleSelectedWorkspace(workspace.space_id)
                              openDeleteDialog()
                            }}
                          >
                            <img src={DeleteIcon} alt="icon" width="13px" />{" "}
                          Delete Workspace
                        </span> */}
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              }
              return ""
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WorkspaceListView;
